import React from 'react'
import { createColumnHelper } from '@tanstack/react-table'
import { useAppSelector } from '../../../../hooks/redux'

import Table from '../../../../components/molecules/Table'
import OverflowText from '../../../../components/atoms/OverflowText'
import EditDelete from '../EditDelete'

import { selectTeams } from '../../../../slices/teamsSlice'

const columnHelper = createColumnHelper<APITeam>()

type TeamsTableProps = {
  openModal: (data: APITeam) => () => void
}

const TeamsTable: React.FC<TeamsTableProps> = ({ openModal }) => {
  const { teams, loaded } = useAppSelector(selectTeams)

  const columns = React.useMemo(() => {
    const nameColumn = columnHelper.accessor('name', {
      header: 'Name'
    })

    const descriptionColumn = columnHelper.accessor('desc', {
      header: 'Description',
      cell: ({ row }) => <OverflowText>{row.original.desc}</OverflowText>
    })

    const membersColumn = columnHelper.accessor('members', {
      header: 'Members',
      cell: ({ row }) => row.original.members.length
    })

    const editColumn = columnHelper.display({
      id: 'edit',
      header: 'Edit / Delete',
      cell: ({ row }) => <EditDelete open={openModal} data={row.original} />
    })

    return [nameColumn, descriptionColumn, membersColumn, editColumn]
  }, [openModal])

  return (
    <Table
      id='teams'
      data={teams}
      columns={columns}
      loaded={loaded}
      message='You have no teams'
      hideCount
      disablePagination
    />
  )
}

export default TeamsTable
